var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBigUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lucide / arrow-big-up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.75 19.5V13H5.41667L13 5.41667L20.5833 13H16.25V19.5H9.75Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#111827"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBigUp);
export default __webpack_public_path__ + "static/media/arrow-big-up.2a8daa8765b75dd162d0d5950e47cbe3.svg";
export { ForwardRef as ReactComponent };